import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"

/**
 * @typedef {object} ComponentsNavItemProps
 * @property {string} active
 * @property {unknown} children
 * @property {string} className
 * @property {string} identifier
 * @property {React.ReactNode} label
 * @property {string} to
 */

/** @typedef {object} ComponentsNavItemState */

/**
 * @extends {ShapeComponent<ComponentsNavItemProps, ComponentsNavItemState>}
 */
class ComponentsNavItem extends ShapeComponent {
  static propTypes = {
    active: PropTypes.string,
    className: PropTypes.string,
    identifier: PropTypes.string,
    label: PropTypes.node,
    to: PropTypes.string
  }

  render() {
    const {active, children, className, identifier, label, to, ...restProps} = this.props

    return (
      <Link
        className={classNames("components--nav--item", className)}
        data-active={active == identifier}
        data-identifier={identifier}
        to={to || "#"}
        {...restProps}
      >
        {label || children}
      </Link>
    )
  }
}

export default memo(shapeComponent(ComponentsNavItem))
